import { Object3D, Sprite, SpriteMaterial, Texture, TextureLoader } from "three";
import spinnerImage from '@assets/images/globe/marker-ring.png'
import emittable from './emittable'

const PI180 = Math.PI / 180;

export default emittable(class Marker extends Object3D {
    constructor(props = {}){
        super();
        Object.assign(this,props);
        this.markerObject = new Sprite(
            new SpriteMaterial({map: this.generateTexture()})
        );
        this.add(this.markerObject);
        //this.scale.set(1,1,1);

        new TextureLoader().load(window.__globeMarkerSpinnerImage || spinnerImage,(map) => {
            this.add(
                this.spinner = new Sprite(
                    new SpriteMaterial({map})
                )
            );

            this.spinner.visible = this.active;

            this.spinner.scale.set(3,3,3);
        })
    }

    tick(delta){
        this.spinner && (this.spinner.material.rotation -= delta / 200);
    }

    get latitude(){
        return this._lat || 0;
    }
    get longitude(){
        return this._lng || 0;
    }
    get radius(){
        return this._radius || 0;
    }

    set latitude(lat){
        this._lat = lat;
        this._updatePosition();
    }
    set longitude(lng){
        this._lng = lng;
        this._updatePosition();
    }
    set radius(radius){
        this._radius = radius;
        this._updatePosition();
    }

    set active(active){
        this._active = active;
        if(this.spinner){
            this.spinner.visible = active;
        }
    }

    get active(){
        if(this._active === undefined){
            this._active = false;
        }
        return this._active;
    }


    _updatePosition(){
        const {radius:rad,latitude:lat,longitude:lon} = this;

        const cosLat = Math.cos(lat * PI180);
        const sinLat = Math.sin(lat * PI180);
        const cosLon = Math.cos(lon * PI180);
        const sinLon = Math.sin(lon * PI180);
        const f = 1.0 / 298.257224;
        const C = 1.0 / Math.sqrt(cosLat * cosLat + (1 - f) * (1 - f) * sinLat * sinLat);
        const S = (1.0 - f) * (1.0 - f) * C;
        const h = 0.0;

        this.position.set(
            (rad * C + h) * cosLat * cosLon,
            (rad * C + h) * cosLat * sinLon,
            (rad * S + h) * sinLat
        );
    }

    generateTexture(){
        const canvas = document.createElement( 'canvas' );
        canvas.width = 32;
        canvas.height = 32;
        const context = canvas.getContext( '2d' );

        context.beginPath();
        context.arc(16, 16, 10, 0, 2 * Math.PI);
        context.fillStyle = "#000000";
        context.fill();

        const texture = new Texture(canvas);
        texture.needsUpdate = true;
        return texture;
    }

})